import styled from 'styled-components';
import { theme } from '../../styles/theme';

const BackgroundWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${theme.zIndex.background};
  overflow: hidden;
`;

const BackgroundImage = styled.div<{ $imageUrl: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.$imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.1) 50%,
    rgba(0, 0, 0, 0) 100%
  );
`;

interface BackgroundProps {
  imageUrl?: string;
}

export function Background({ imageUrl = '/asset/scene.jpg' }: BackgroundProps) {
  return (
    <BackgroundWrapper>
      <BackgroundImage $imageUrl={imageUrl} />
      <Overlay />
    </BackgroundWrapper>
  );
} 